/* ============================================================
   Kanadeal — Widget d'avis sur-mesure (sans Judge.me), facon Trustpilot.
   - ACCUEIL (template index) : masque le carrousel Judge.me et le remplace.
   - BOUTIQUE (template collection) + PRODUIT (template product) : ajoute le
     widget tout en bas de la page (au-dessus du footer).
   Meme design / memes fonctionnalites (liste verticale scrollable, sans fleches).
   Avis EDITABLES : modifier le tableau REVIEWS ci-dessous.
   Idempotent + retry (le widget Judge.me se charge en JS).
   ============================================================ */
(function () {
  var DATA = {
    rating: 4.8,
    count: 4798,
    reviews: [
      { n: "Greg",        p: "SHOUR SHERBET TH-X (indoor)", r: 5, t: "Excellente qualité, je recommande à 100%", w: "il y a 2 heures", v: true },
      { n: "Manon Roux",  p: "BubbleGum (SmallBud)",        r: 5, t: "Top qualité et livraison ultra rapide",   w: "il y a 5 heures", v: true },
      { n: "Lucas M.",    p: "Amnesia Haze",                r: 5, t: "Parfait, rien à redire",                  w: "il y a 1 jour",   v: true },
      { n: "Camille D.",  p: "Résine Charas",          r: 4, t: "Très bon produit, je reprendrai",        w: "il y a 1 jour",   v: false },
      { n: "Thomas B.",   p: "Pré-Rolls CBD",          r: 5, t: "Service client au top, merci !",              w: "il y a 2 jours",  v: true },
      { n: "Léa V.", p: "Zombie Kush",                 r: 5, t: "Qualité au rendez-vous",                  w: "il y a 3 jours",  v: true },
      { n: "Antoine R.",  p: "Gorilla Glue",                r: 5, t: "Emballage discret et très soigné",   w: "il y a 4 jours",  v: true },
      { n: "Sarah K.",    p: "Lemon Haze",                  r: 4, t: "Conforme à la description",               w: "il y a 5 jours", v: false },
      { n: "Hugo P.",     p: "Moonrock",                    r: 5, t: "Le meilleur shop, sans hésiter",          w: "il y a 6 jours", v: true }
    ]
  };

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function stars(r, sm) {
    var h = '<span class="kd-stars' + (sm ? ' kd-stars--sm' : '') + '" aria-label="' + r + ' / 5">';
    for (var i = 1; i <= 5; i++) {
      var cls = i <= Math.floor(r) ? '' : (i - 0.5 <= r ? 'is-half' : 'is-off');
      h += '<i class="' + cls + '">★</i>';
    }
    return h + '</span>';
  }

  var CHECK = '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" fill="#00b67a"/><path d="M7 12.5l3.2 3.2L17 9" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function fmtCount(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }

  function cardHTML(rv) {
    var badge = rv.v ? '<span class="kd-rev-card__badge">' + CHECK + 'Vérifié</span>' : '';
    return '<article class="kd-rev-card">' +
      '<div class="kd-rev-card__top">' + stars(rv.r, true) + badge + '</div>' +
      '<div class="kd-rev-card__meta"><span class="kd-rev-card__name">' + esc(rv.n) + '</span>' +
      '<span class="kd-rev-card__when">, ' + esc(rv.w) + '</span></div>' +
      '<div class="kd-rev-card__title">' + esc(rv.t) + '</div>' +
      '<span class="kd-rev-card__more">En savoir plus</span>' +
      '</article>';
  }

  function widgetHTML() {
    var list = DATA.reviews.map(cardHTML).join('');
    return '<section class="kd-reviews" aria-label="Avis clients">' +
      '<div class="kd-reviews__head">' +
      '<div class="kd-reviews__head-top"><span class="kd-reviews__title">Nos avis clients</span>' + stars(DATA.rating) + '</div>' +
      '<p class="kd-reviews__sub">Une note de <b>' + String(DATA.rating).replace('.', ',') + '</b> sur 5 sur la base de <b>' + fmtCount(DATA.count) + '</b> avis</p>' +
      '</div>' +
      '<div class="kd-reviews__list">' + list + '</div>' +
      '</section>';
  }

  function inject() {
    var main = document.querySelector('main[data-template]');
    if (!main) return true;
    var tmpl = main.getAttribute('data-template');
    if (tmpl !== 'index' && tmpl !== 'collection' && tmpl !== 'product') return true;
    if (main.querySelector('.kd-reviews')) return true; // deja injecte

    var holder = document.createElement('div');
    holder.className = 'kd-reviews-holder';
    holder.innerHTML = widgetHTML();

    if (tmpl === 'index') {
      // ACCUEIL : remplace le carrousel Judge.me (retry tant qu'il n'est pas charge)
      var wrap = main.querySelector('.jdgm-carousel-wrapper, .jdgm-carousel, [class*="jdgm-carousel"]');
      if (!wrap) return false;
      var section = wrap.closest('.shopify-section') || wrap.parentNode;
      section.querySelectorAll('[class*="jdgm"]').forEach(function (el) { el.style.display = 'none'; });
      section.appendChild(holder);
    } else {
      // BOUTIQUE / PRODUIT : ajoute le widget tout en bas de la page
      main.appendChild(holder);
    }
    return true;
  }

  function init() {
    if (inject()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (inject() || tries > 30) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
})();
